import { mapBackendUserToUser, User } from './User';

export type LoginRequest = {
  email: string;
  password: string;
  remember_me: boolean;
};

export type LoginResponse = {
  microsoftToken?: any;
  token: string;
  user: User;
};

// MAPPER
export const loginMapper = (response: any): LoginResponse => ({
  microsoftToken: response.data.microsoft_token,
  token: response.data.token,
  user: mapBackendUserToUser(response.data.user),
});
